import ValueExistingInCollection from "./value-existing-in-collection.js";
import { CollectionItem, Context, Field } from "../../../main.js";
import { OpenApiTypes } from "../../../schemas/open-api-types.js";

export default class ValueNotExistingInCollection extends ValueExistingInCollection {
	getTypeName = () => "value-not-existing-in-collection";
	open_api_type = OpenApiTypes.NONE; // unknown without context :C
	async isProperValue(
		context: Context,
		new_value: unknown,
		old_value: unknown,
		_blessing: unknown,
		item: CollectionItem | undefined
	) {
		const field = this.getField(context.app);
		if (!field) {
			throw new Error("field is missing");
		}

		await field.checkValue(context, new_value, old_value, null, item);
		if (this.include_forbidden) {
			context = new this.app.SuperContext();
		}
		const sealious_response = await field.collection
			.list(context)
			.filter({ [field.name]: new_value })
			.fetch();
		if (!sealious_response.empty) {
			return Field.invalid(
				context.i18n`Collection ${field.collection.name} already has a record with '${field.name}' set to '${String(new_value)}'.`
			);
		}
		return Field.valid();
	}

	getPostgreSqlFieldDefinitions(): string[] {
		const baseFieldsDefs = super.getPostgreSqlFieldDefinitions();
		return baseFieldsDefs.map((field) => `${field} UNIQUE`);
	}
}
